import React, { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import MainApp from "views/main-app";

import Login from "views/login/login.js";
import PrivateRoute from "util/private-route.js";
import "./scss/style.scss";
import {
  USER_STORAGE,
  FIRST_PAGE,
  ROLE_USER,
  FIRST_PAGE_USER,
  ROLE_ADMIN,
} from "./constants";
import { useSelector } from "react-redux";
import { selectRole } from "reducer/login/login-user";
import Page404 from "views/404/Page404";
import ManagerialAdmin from "views/admin/managerial/managerial-admin";
import UsersAdminTab from "views/admin/users/users-admin-tab";
import ManagerialCustomer from "views/admin/managerial/managerial-customer";

const RouterApp = (props) => {
  const [roleRedux, setRoleRedux] = useState(useSelector(selectRole));

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { role } = JSON.parse(localStorageItem);
      if (roleRedux == "" || role != roleRedux) {
        setRoleRedux(role);
      }
    }
  }, []);

  function getNavegateApp() {
    let navegateApp =
      null == roleRedux || "" == roleRedux
        ? "/login"
        : roleRedux == ROLE_ADMIN
        ? FIRST_PAGE
        : FIRST_PAGE_USER;

    return navegateApp;
  }
  setTimeout(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);

    if (localStorageItem != null) {
      const { role } = JSON.parse(localStorageItem);
      if (roleRedux == "" || role != roleRedux) {
        setRoleRedux(role);
      }
    }
  }, 1000);

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route
            path="/app"
            element={<Navigate to={getNavegateApp()} replace />}
          />

          {roleRedux == ROLE_ADMIN && (
            <Route
              path="/app/admin"
              element={<Navigate to={getNavegateApp()} replace />}
            />
          )}
          {roleRedux == ROLE_USER && (
            <Route
              path="/app/customer"
              element={<Navigate to={getNavegateApp()} replace />}
            />
          )}

          <Route exact path="/app" element={<PrivateRoute />}>
            {roleRedux == ROLE_USER && (
              <>
                <Route
                  path="/app/customer/managerial"
                  element={<MainApp component={<ManagerialCustomer />} />}
                />
              </>
            )}

            {roleRedux == ROLE_ADMIN && (
              <>
                <Route
                  path="/app/admin/managerial"
                  element={<MainApp component={<ManagerialAdmin />} />}
                />

                <Route
                  path="/app/admin/users"
                  element={<MainApp component={<UsersAdminTab />} />}
                />
              </>
            )}
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default RouterApp;
